// extracted by mini-css-extract-plugin
module.exports = {"sectionControlContainer":"style-module_sectionControlContainer__GRsWmd9wb5mKdm9snlqPQ"};